import { TimesheetEarningsStatus } from '@aslanpay/portal-common-lib';

type EarningsStatusBadge = 'active' | 'warning' | 'paused' | 'deleted';

interface EarningsStatusDetail {
  label: string;
  description: string;
  badgeStatus: EarningsStatusBadge;
}

export const EarningsStatusDetails: Record<TimesheetEarningsStatus, EarningsStatusDetail> = {
  ACTIVE: {
    label: 'Active',
    description: 'Live earnings available to draw from for this pay cycle.',
    badgeStatus: 'active',
  },
  EXPIRED: {
    label: 'Expired',
    description: 'Past the pay cycle cut-off, so no longer available to draw from.',
    badgeStatus: 'warning',
  },
  SUPERSEDED: {
    label: 'Superseded',
    description: 'Replaced by a newer timesheet upload for the same day.',
    badgeStatus: 'paused',
  },
  VOID: {
    label: 'Void',
    description: 'Manually voided and excluded from earnings.',
    badgeStatus: 'deleted',
  },
};
